import { IChartContainer } from "../models/base/chart-container.interface";
import { LimitAlertModel } from "../models/limit-alert/limit-alert.model";
import { IComponent } from "./component.interface";
import { LimitAlertPlotLineComponent } from "./limit-alert-plot-line.component";

export class DrawLimitAlertsComponent implements IComponent {
    public id = '';

    private base: IChartContainer;;
    private limitAlerts: Array<LimitAlertModel> = [];
    private limitAlertPlotLines: Array<LimitAlertPlotLineComponent> = [];
    private isRemovingForSwitchingSymbol = false;

    constructor(base: IChartContainer) {
        this.base = base;
        this.subscribeDrawLimitAlerts();
    }

    public remove() {
        this.isRemovingForSwitchingSymbol = true;
        for (let i = 0; i < this.limitAlertPlotLines.length; i++) {
            this.limitAlertPlotLines[i].remove();
            delete this.limitAlertPlotLines[i];
        }

        this.limitAlerts = [];
        this.limitAlertPlotLines = [];

        this.isRemovingForSwitchingSymbol = false;
    }

    private drawLimitAlertsTimer: any;
    private subscribeDrawLimitAlerts() {
        this.base.chartService.subscribePriceAlertsData((limitAlerts: Array<LimitAlertModel>) => {
            if (this.isRemovingForSwitchingSymbol) {
                return;
            }

            const anyPlotLineMoving = this.limitAlertPlotLines.some((x: LimitAlertPlotLineComponent) => x.moveMode || x.selected);
            if (anyPlotLineMoving)  return;

            clearTimeout(this.drawLimitAlertsTimer);
            this.drawLimitAlertsTimer = setTimeout(() => {
                this.limitAlerts = limitAlerts;
                this.removeLimitAlertLines();
                this.createOrUpdateLimitAlertLines();
            }, 100);
        });
    }

    private removeLimitAlertLines() {
        for (let i = 0; i < this.limitAlertPlotLines.length; i++) {
            this.limitAlertPlotLines[i].remove();
        }

        this.limitAlertPlotLines = [];
    }

    private createOrUpdateLimitAlertLines() {
        for (const limitAlert of this.limitAlerts) {
            this.limitAlertPlotLines.push(new LimitAlertPlotLineComponent(this.base, limitAlert));
        }
    }
}